import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { addressProofType, cityList, countryList, entityTypeList, stateList, updateKyc, uploadAddressProof, uploadGstin, uploadPan } from '../../../action/profile'
import { toast } from 'react-toastify';
import { validateFunctionalForm } from '../../../utils';
import constant from '../../../constant';


const Index = ({ details }) => {
    const [state, setState] = useState({
        entityType: { name: "entityType", value: details?.ENTITY_TYPE_ID || "", options: [], error: [], isRequired: true },
        address: { name: "address", value: details?.ADDRESS || "", options: [], error: [], isRequired: true },
        country: { name: "country", value: details?.COUNTRY_ID || "", options: [], error: [], isRequired: true },
        state: { name: "state", value: details?.STATE_ID || "", options: [], error: [], isRequired: true },
        city: { name: "city", value: details?.CITY_ID || "", options: [], error: [], isRequired: true },
        pin: { name: "pin", value: details?.PINCODE || "", options: [], error: [], isRequired: true },
        addressProof: { name: "addressProof", value: details?.ADDRESS_PROOF_TYPE_ID || "", options: [], error: [], isRequired: false },
        uploadAddressProofType: { name: "uploadAddressProofType", value: details?.UPLOAD_ADDRESS_PROOF || "", options: [], error: [], isRequired: false },
        nameonPanCard: { name: "nameonPanCard", value: details?.NAME_ON_PAN || "", options: [], error: [], isRequired: true },
        panCardStatus: { name: "panCardStatus", value: details?.PAN_CARD_STATUS || "", options: [], error: [], isRequired: true },
        pan: { name: "pan", value: details?.PAN_NUMBER || "", options: [], error: [], isRequired: false },
        uploadPan: { name: "uploadPan", value: details?.UPLOAD_PAN || "", options: [], error: [], isRequired: false },
        gst: { name: "gst", value: details?.GST || "", options: [], error: [], isRequired: true },
        gstin: { name: "gstin", value: details?.GSTIN || "", options: [], error: [], isRequired: true },
        uploadGstinCertificate: { name: "uploadGstinCertificate", value: details?.UPLOAD_GSTIN_CERTIFICATE || "", options: [], error: [], isRequired: false },
        tanNumber: { name: "tanNumber", value: details?.TAN_NUMBER || "", options: [], error: [], isRequired: false },
    });

    const setOptions = (fieldName, options) => {
        setState((prevState) => ({
            ...prevState,
            [fieldName]: { ...prevState[fieldName], options },
        }));
    };

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const countryRes = await countryList();
                if (countryRes.status) {
                    setOptions("country", countryRes.result.list);
                } else {
                    throw new Error(countryRes.error);
                }

                const entityTypeRes = await entityTypeList();
                if (entityTypeRes.status) {
                    setOptions("entityType", entityTypeRes.result);
                } else {
                    throw new Error(entityTypeRes.error);
                }

                const addressProofRes = await addressProofType();
                if (addressProofRes.status) {
                    setOptions("addressProof", addressProofRes.result);
                } else {
                    throw new Error(addressProofRes.error);
                }

                if (details) {
                    const stateRes = await stateList(parseInt(details.COUNTRY_ID));
                    if (stateRes.status) {
                        setOptions("state", stateRes.result.list);
                    } else {
                        throw new Error(stateRes.error);
                    }

                    const cityRes = await cityList(parseInt(details.STATE_ID));
                    if (cityRes.status) {
                        setOptions("city", cityRes.result.list);
                    } else {
                        throw new Error(cityRes.error);
                    }
                }
            } catch (error) {
                console.error("Error loading dropdown data:", error.message);
                alert(error.message);
            }
        };

        fetchDropdownData();
    }, [details]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: { ...prev[name], value },
        }));

        if (name === "gst" && value === "Y") {
            setState((prev) => ({
                ...prev,
                gstin: { ...prev.gstin, isRequired: false },
            }));
        }
    };

    const handleFileUpload = async (e, uploadFunc) => {
        e.preventDefault();
        const fieldName = e.target.name
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("file", file);

        try {
            const res = await uploadFunc(formData);
            if (res.status) {
                handleChange({ target: { name: fieldName, value: res.result.fileName } });
                toast.success("File uploaded successfully.");
            } else {
                toast.error(res.error);
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error("An error occurred during file upload.");
        }
    };

    useEffect(() => {
        stateList(parseInt(state.country.value))
            .then((res) => {
                if (res.status) {
                    setOptions(state.state.name, res.result.list);
                } else {
                    alert(res.error);
                }
            })
            .catch((err) => {
                alert(err);
            });

    }, [state.country.value])

    useEffect(() => {

        cityList(parseInt(state.state.value))
            .then((res) => {
                if (res.status) {
                    setOptions(state.city.name, res.result.list);
                } else {
                    alert(res.error);
                }
            })
            .catch((err) => {
                alert(err);
            });
    }, [state.state.value])
    const handleSubmit = async (e) => {
        debugger
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {

            const model = {
                ENTITY_TYPE_ID: state.entityType.value,
                ADDRESS: state.address.value,
                COUNTRY_ID: state.country.value,
                STATE_ID: state.state.value,
                CITY_ID: state.city.value,
                PINCODE: state.pin.value,
                ADDRESS_PROOF_TYPE_ID: state.addressProof.value,
                UPLOAD_ADDRESS_PROOF: state.uploadAddressProofType.value,
                NAME_ON_PAN: state.nameonPanCard.value,
                PAN_CARD_STATUS: state.panCardStatus.value,
                PAN_NUMBER: state.pan.value,
                UPLOAD_PAN: state.uploadPan.value,
                GST: state.gst.value,
                GSTIN: state.gstin.value,
                UPLOAD_GSTIN_CERTIFICATE: state.uploadGstinCertificate.value,
                TAN_NUMBER: state.tanNumber.value,
            };


            try {
                const res = await updateKyc(model);
                if (res.status) {
                    toast.success(res.result.message)
                } else {
                    toast.error(res.error);
                }
            } catch (error) {
                console.error("KYC submission error:", error);
                toast.error("Submission failed. Try again.");
            }
        }

    };
    return (
        <section className='my-1'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href={constant.component.dashboard.url}>Dashboard</a></li>
                                <li className="breadcrumb-item active" aria-current="page">KYC</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className={`${styles['kyc-card']}`}>
                            <h2 className={`${styles['main-title']} mb-2`}>KYC Form</h2>
                            <form
                                onSubmit={handleSubmit}
                            >
                                <div className="mb-3">
                                    <label className={`${styles['label-ct']} form-label`}>Entity Type <span className="text-danger ps-1">*</span></label>
                                    <select className={
                                        state.entityType?.error.length > 0
                                            ? "form-select is-invalid"
                                            : "form-select"
                                    }
                                        name={state.entityType.name}
                                        value={state.entityType.value}
                                        onChange={handleChange}
                                    >
                                        <option value="">
                                            Select Entity type
                                        </option>
                                        {state.entityType.options &&
                                            state.entityType.options.map(function (
                                                item,
                                                index
                                            ) {
                                                return (
                                                    <option
                                                        key={index}
                                                        value={item.ENTITY_TYPE_ID}
                                                    >
                                                        {item.ENTITY_TYPE}
                                                    </option>
                                                );
                                            })}
                                    </select>
                                </div>

                                <div className="row">
                                    <div className='col-md-6'>
                                        <div className="mb-3">
                                            <label className={`${styles['label-ct']} form-label`}>Address <span className="text-danger ps-1">*</span></label>
                                            <input className={
                                                state.address.error.length > 0
                                                    ? "form-control is-invalid"
                                                    : "form-control"
                                            }
                                                type="text"
                                                name={state.address.name}
                                                value={state.address.value}
                                                onChange={handleChange}
                                                placeholder="Enter Your Address" />
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>Country <span className="text-danger ps-1">*</span></label>
                                        <select
                                            className={
                                                state.country.error.length > 0
                                                    ? "form-select is-invalid"
                                                    : "form-select"
                                            }
                                            name={state.country.name}
                                            value={state.country.value}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Country</option>
                                            {state.country.options &&
                                                state.country.options.map(function (
                                                    item,
                                                    index
                                                ) {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={item.COUNTRY_ID}
                                                        >
                                                            {item.COUNTRY}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>State <span className="text-danger ps-1">*</span></label>
                                        <select
                                            className={
                                                state.state.error.length > 0
                                                    ? "form-select is-invalid"
                                                    : "form-select"
                                            }
                                            name={state.state.name}
                                            value={state.state.value}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select State</option>
                                            {state.state.options &&
                                                state.state.options.map(function (
                                                    item,
                                                    index
                                                ) {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={item.STATE_ID}
                                                        >
                                                            {item.STATE}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>City <span className="text-danger ps-1">*</span></label>
                                        <select
                                            className={
                                                state.city.error.length > 0
                                                    ? "form-select is-invalid"
                                                    : "form-select"
                                            }
                                            name={state.city.name}
                                            value={state.city.value}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select City</option>
                                            {state.city.options &&
                                                state.city.options.map(function (
                                                    item,
                                                    index
                                                ) {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={item.CITY_ID}
                                                        >
                                                            {item.CITY}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>Pincode <span className="text-danger ps-1">*</span></label>
                                        <input
                                            className={
                                                state.pin.error.length > 0
                                                    ? "form-control is-invalid"
                                                    : "form-control"
                                            }
                                            type="text"
                                            name={state.pin.name}
                                            value={state.pin.value}
                                            onChange={handleChange}
                                            placeholder="Enter Pincode"
                                        />
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className="col-md-6 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>Address Proof Type </label>
                                        <select
                                            className={
                                                state.addressProof.error.length > 0
                                                    ? "form-select is-invalid"
                                                    : "form-select"
                                            }
                                            name={state.addressProof.name}
                                            value={state.addressProof.value}
                                            onChange={handleChange}
                                        >
                                            <option value="">
                                                Select Address Proof Type
                                            </option>
                                            {state.addressProof.options &&
                                                state.addressProof.options.map(function (
                                                    item,
                                                    index
                                                ) {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={item.ADDRESS_PROOF_TYPE_ID}
                                                        >
                                                            {item.ADDRESS_PROOF_TYPE}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>Upload Address Proof </label>
                                        <div className='position-relative'>
                                            <input className={
                                                state.uploadAddressProofType.error.length > 0
                                                    ? "form-control is-invalid"
                                                    : "form-control"
                                            }
                                                type="file"
                                                name={state.uploadAddressProofType.name}
                                                onChange={(e) => { handleFileUpload(e, uploadAddressProof) }} />
                                            {details ? (
                                                <a
                                                    className={`${styles['linkct-ctm']}`}
                                                    target="_blank"
                                                    href={`${process.env.REACT_APP_BASE_URL}/company/address-proof/${details.UPLOAD_ADDRESS_PROOF}`}
                                                >
                                                    View File
                                                    {/* {details.UPLOAD_ADDRESS_PROOF} */}
                                                </a>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>


                                    <div className="col-md-6 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>PAN Card Status <span className="text-danger ps-1">*</span></label>
                                        <select
                                            className={
                                                state.panCardStatus.error.length > 0
                                                    ? "form-select is-invalid"
                                                    : "form-select"
                                            }
                                            name={state.panCardStatus.name}
                                            value={state.panCardStatus.value}
                                            onChange={handleChange}
                                        >
                                            <option value="">
                                                Select Status
                                            </option>
                                            <option value="Y">
                                                I have company's PAN card
                                            </option>
                                            <option value="N">
                                                Applied for company's PAN card
                                            </option>
                                        </select>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>Name on PAN Card </label>
                                        <input
                                            className={
                                                state.nameonPanCard.error.length > 0
                                                    ? "form-control is-invalid"
                                                    : "form-control"
                                            }
                                            name={state.nameonPanCard.name}
                                            value={state.nameonPanCard.value}
                                            onChange={handleChange}
                                            type="text"
                                            placeholder="Enter the name on PAN Card"
                                        />
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className="col-md-6 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>PAN</label>
                                        <input
                                            className={
                                                state.pan.error.length > 0
                                                    ? "form-control is-invalid"
                                                    : "form-control"
                                            }
                                            name={state.pan.name}
                                            value={state.pan.value}
                                            onChange={handleChange}
                                            type="text"
                                            placeholder="Please enter PAN Number"
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>Upload PAN </label>
                                        <div className='position-relative'>
                                            <input
                                                className={
                                                    state.uploadPan.error.length > 0
                                                        ? "form-control is-invalid"
                                                        : "form-control"
                                                }
                                                type="file"
                                                name={state.uploadPan.name}
                                                onChange={(e) => { handleFileUpload(e, uploadPan) }} />
                                            {details ? (
                                                <a
                                                    className={`${styles['linkct-ctm']}`}
                                                    target="_blank"
                                                    href={`${process.env.REACT_APP_BASE_URL}/company/pan/${details.UPLOAD_PAN}`}
                                                >
                                                    View File
                                                    {/* {details.UPLOAD_PAN} */}
                                                </a>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className="col-md-6 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>GST <span className="text-danger ps-1">*</span></label>
                                        <select
                                            className={
                                                state.gst.error.length > 0
                                                    ? "form-select is-invalid"
                                                    : "form-select"
                                            }
                                            name={state.gst.name}
                                            value={state.gst.value}
                                            onChange={handleChange}
                                        >
                                            <option value=""> Select GST </option>
                                            <option value="Y"> Registered </option>
                                            <option value="N"> UnRegistered </option>
                                        </select>
                                    </div>

                                    {state.gst.value === 'Y' &&
                                        <React.Fragment>

                                            <div className="col-md-6 mb-3">
                                                <label className={`${styles['label-ct']} form-label`}>GST Number <span className="text-danger ps-1">*</span></label>
                                                <input
                                                    className={
                                                        state.gstin.error.length > 0
                                                            ? "form-control is-invalid"
                                                            : "form-control"
                                                    }
                                                    type="text"
                                                    name={state.gstin.name}
                                                    value={state.gstin.value}
                                                    onChange={handleChange}
                                                    placeholder="Please enter GST Number"
                                                />
                                            </div>

                                        </React.Fragment>
                                    }
                                </div>
                                <div
                                    className='row'
                                >
                                    {state.gst.value === 'Y' &&
                                        <div className="col-md-6 mb-3">
                                            <label className={`${styles['label-ct']} form-label`}> Upload GSTIN Certificate </label>
                                            <div className='position-relative'>
                                                <input
                                                    className={
                                                        state.uploadGstinCertificate.error.length > 0
                                                            ? "form-control is-invalid"
                                                            : "form-control"
                                                    }
                                                    type="file"
                                                    name={state.uploadGstinCertificate.name}
                                                    onChange={(e) => { handleFileUpload(e, uploadGstin) }} />
                                                {details ? (
                                                    <a
                                                        className={`${styles['linkct-ctm']}`}
                                                        target="_blank"
                                                        href={`${process.env.REACT_APP_BASE_URL}/company/gst-certificate/${details.UPLOAD_GSTIN_CERTIFICATE}`}
                                                    >
                                                        View File
                                                        {/* {details.UPLOAD_GSTIN_CERTIFICATE} */}
                                                    </a>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </div>

                                    }
                                    <div className="col-md-6 mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>TAN </label>
                                        <input
                                            className="form-control"
                                            name={state.tanNumber.name}
                                            value={state.tanNumber.value}
                                            onChange={handleChange}
                                            type="text"
                                            placeholder="Enter TAN Number"
                                        />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <button type="button" className={`${styles['cancel-btn']} btn`}>Cancel</button>
                                    <button type="submit" className={`${styles['submit-btn']} btn ms-2`}>Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Index